/**
 * 数组对象转树对象
 * @param array
 * @param id
 * @param pid
 * @param children
 * @param itemCallback
 * @returns {Array}
 */
export function array2tree(array, id, pid, children, itemCallback) {
  var data = _.cloneDeep(array), result = [], hash = {}
  _.forEach(array, function (item, index) {
    hash[data[index][id]] = data[index]
  })
  _.forEach(data, function (item) {
    var hashVP = hash[item[pid]]
    !!itemCallback && itemCallback(item)
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = [])
      hashVP[children].push(item)
    } else {
      result.push(item)
    }
  })
  return result
}

/**
 * 随机数字
 * @param low
 * @param high
 * @returns {number}
 */
function getRandomNum(low, high) {
  return Math.floor(Math.random() * (high - low + 1) + low)
}

/**
 * 随机长度字符 ed是否必须含英文
 * @param len
 * @param isEd
 * @returns {string}
 */
export function getRandomChar(len, isEd) {
  let seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9']
  let seedlen = seed.length, randomChar = ''
  for (let i = 0; i < len; i++) {
    var j = Math.floor(Math.random() * seedlen);
    randomChar += seed[j];
  }
  // 是否必须含其一
  if (isEd) {
    if (/^\d+$/.test(randomChar)) {
      randomChar = randomChar.split("")
      randomChar.splice(getRandomNum(0, len - 1), 1, 'P')
      randomChar = randomChar.join("");
    } else if (!/\d+/.test(randomChar)) {
      randomChar = randomChar.split("");
      randomChar.splice(getRandomNum(0, len - 1), 1, '7')
      randomChar = randomChar.join("");
    }
  }
  return randomChar;
}

export default {
  array2tree,
  getRandomChar
}



// WEBPACK FOOTER //
// ./src/utils/supt.js